import { NavMarker } from 'react-rhumb';
import { PageWrapper } from '../../PageWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubSpotCreditsPage = () => {
  return (
    /*#__PURE__*/
    // TODO: Add the actual content for the HubSpot Credits page
    _jsx(PageWrapper, {
      navItem: "hubspot-credits",
      children: /*#__PURE__*/_jsx(NavMarker, {
        name: "HUBSPOT_CREDITS_PAGE_V2",
        children: "HubSpot Credits Page"
      })
    })
  );
};